import React from 'react'



const CustomPagination = ({ links, onPaginate }) => {
    return (
        <nav>
            <ul class="pagination" >
                {
                    links.map((link) => (
                        <li 
                            class={`page-item ${link.url == null || link.active ? 'disabled' : 'active'} m-2`} >
                            <a onClick={() => onPaginate(link)} class="page-link" tabindex="1">
                                {link.label == 'Next &raquo;' ? <span>&raquo;</span> : link.label == "&laquo; Previous" ? <span>&laquo;</span> : link.label}
                            </a>
                        </li>
                    ))
                }

            </ul>
        </nav>
    )
}

export default CustomPagination